export enum Paths {
  admin = "admin",
  demo = 'demo',
  form = 'form',
  table = 'table',
  serverTable = 'server-table',
  button = 'button',
  card = 'card',
  dialog = 'dialog',
  input = 'input',
  select = 'select',
  radioCheckbox = 'radio-checkbox',
  authentication = "authentication",
  home = "home",
  events = "events",
  aboutus = "about-us",
  coursesCategory = "courses-category",
  login = "login",
  register = "register",
  contact = "contact",
  dashboard = "dashboard",
  adminLogin = "admin-login",
  course = "course",
  gallery = "gallery",
  galleryAdd = "gallery-add",
  users = "users",
  userAdd = "user-add",
  galleryCategory = "gallery-category",
  galleryCategoryForm = "gallery-category-form",
  add = "add",
  update = "update",
  courseCategory = "course-category",
  courseCategoryForm = "course-category-form",
  courseSubCategoryForm = "course-subcategory-form",
  courseForm = "course-form",
  coursesinquiry = "courses-inquiry",
  courseSubCategory = "course-subcategory",
  banners = "banners"
}